<template>
    <div>
        <Filtres v-if="filters" @filter-change="onFilterChange" :nb-results="eventsFiltered.length" ref="filtres"/>
        <div class="tw-relative">
            <Carte v-if="mapLoaded" :markers="eventsFiltered"/>
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-screen tw-w-screen" v-else>
                <p class="text-1-8 tw-text-center">Chargement de la carte</p>
                <v-progress-linear
                        class="tw-w-96"
                        color="primary accent-4"
                        rounded
                        height="6"
                        indeterminate
                ></v-progress-linear>
            </div>
            <div v-if="filters && foreignRegions" class="tw-hidden md:tw-flex tw-items-start tw-flex-col tw-gap-8 boutons-map">
                <v-btn color="yellow" class="btn-shape"
                       @click="$refs.filtres.filterForeignRegion('metropole')">
                    Métropole
                </v-btn>
                <v-btn v-for="(region , index) in foreignRegions" color="yellow" class="btn-shape"
                       :key="index"
                       @click="$refs.filtres.filterForeignRegion(region.termTaxonomyId)">
                    {{ region.name }}
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import Carte from "./Carte";
import evenementsGql from "@/queries/CarteEvenements.graphql"
import foreignGql from "@/queries/DOMTOMForeign.graphql"
import Filtres from "../Events/Filtres";
import moment from "moment";
export default {
    name: "MapContainer",
    components: {Filtres, Carte},
    props : ['filters'],
    data () {
        return {
            pageIndex : null,
            eventsFetched : [],
            events : null,
            eventsFiltered : [],
            mapLoaded : false,
        }
    },
    apollo: {
        evenements: {
            query : evenementsGql,
            variables() {
                return {
                    after : this.pageIndex
                }
            }
        },
        regions : foreignGql,

    },
    watch : {
        evenements: function (newValue , oldValue) {
            if(oldValue && oldValue.pageInfo.endCursor === newValue.pageInfo.endCursor) {
                return false
            }
            this.eventsFetched = this.eventsFetched.concat(newValue.nodes);
            if(newValue.pageInfo.hasNextPage) {
                this.pageIndex = newValue.pageInfo.endCursor
            }
            this.checkEventsDates(this.eventsFetched)
        }
    },
    computed : {
        foreignRegions() {
            if(!this.regions) return false
            let foreign = []
            for (const foreignElement of this.regions.nodes) {
                for (const region of foreignElement.children.nodes) {
                    if(region.evenements.nodes.length > 0) {
                        foreign.push(region)
                    }
                }
            }
            return foreign
        }
    },
    methods : {
        checkMultiplePositions(dates , date) {
            var count = dates.reduce(function(n, val) {
                return n + (val.acfEvent.dates[0].latitude === date.latitude && val.acfEvent.dates[0].longitude === date.longitude);
            }, 0);
            if(count >= 1) {
                return true
            }
            return false
        },
        checkEventsDates(events) {
            let programmeComplet = []
            events.forEach((event) => {
                const nbDates = event.acfEvent.dates.length

                if (nbDates > 1) {

                    const horaires = event.acfEvent.dates.slice();

                    let dates = [];

                    for(let i = 0; i < nbDates; i++) {

                        let horaire = horaires[i]

                        // si plusieurs fois au même endroit mais dates différentes
                        if(this.checkMultiplePositions(dates, horaire)) {
                            var duplicatedDate = dates.find(obj => {
                                return obj.acfEvent.dates[0].latitude === horaire.latitude && obj.acfEvent.dates[0].longitude === horaire.longitude
                            })
                            duplicatedDate.acfEvent.dates.push(horaire)
                        } else {
                            let eventClone = JSON.parse(JSON.stringify(event))
                            eventClone.acfEvent.dates = [horaire]
                            dates.push(eventClone)
                        }

                    }

                    programmeComplet.push(...dates)

                } else { // si une seule date
                    programmeComplet.push(event)
                }

            })

            this.events = programmeComplet
            this.eventsFiltered = programmeComplet.filter( event => this.checkFilterYear(new Date().getFullYear() , event) )
            this.mapLoaded = true
        },

        onFilterChange(filters) {
            if(filters.dates.length === 0 && filters.regions.length === 0 && filters.tags.length === 0) {
                this.eventsFiltered = this.events.filter( event => this.checkFilterYear(filters.year , event) )
                return true
            }
            const eventsFiltered = this.events.filter( event => this.checkFilterYear(filters.year , event) && this.checkFilterRegion(filters.regions , event) && this.checkFilterDate(filters.dates , event) && this.checkFilterTag(filters.tags , event) )
            this.eventsFiltered = eventsFiltered
        },

        checkFilterYear(filterYear , event) {


            const eventYear = (moment(event.acfEvent.dates[0].dateDebut, "DD-MM-YYYY")).year()

            if(filterYear === eventYear) {
                return true
            }

            return false
        },

        checkFilterDate(filterDates , event) {
            if(filterDates.length === 0) return true

            for (const dateEvent of event.acfEvent.dates) {

                if(dateEvent.dateFin) {

                    for (const date of filterDates) {
                        const dateToCheck = (moment(date, "DD-MM-YYYY"))
                        const startingDate = (moment(dateEvent.dateDebut, "DD-MM-YYYY"))
                        const endingDate = (moment(dateEvent.dateFin, "DD-MM-YYYY"))

                        const checkIsBetween = moment(dateToCheck).isBetween( startingDate, endingDate , undefined , [])
                        if(checkIsBetween) {
                            return true
                        }
                    }
                    return false
                }
                if(filterDates.includes(dateEvent.dateDebut)) return true
            }
            return false
        },

        checkFilterRegion(filterRegions , event) {
            if(filterRegions.length === 0) return true
            if(event.regions.nodes.length === 0) return false
            if(filterRegions.includes('metropole')) {
                if (event.regions.nodes[0].parentDatabaseId === 6) return true
            }
            return filterRegions.includes(event.regions.nodes[0].termTaxonomyId)
        },

        checkFilterTag(filterTags , event) {
            if(filterTags.length === 0) return true
            if(event.types.nodes.length === 0) return false
            return event.types.nodes.some(r => filterTags.includes(r.termTaxonomyId))
        },

    }
}
</script>

<style scoped>

</style>